"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaCarouselPaginationStep = void 0;
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Image = require("../Image");
var _VideoPlaceholder = require("./VideoPlaceholder");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MediaCarouselPaginationStep = ({
  mediaCarouselItem,
  hidden,
  isActive,
  slideIndex,
  onPaginationStepClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    palette
  } = (0, _mui.useTheme)();
  const onClick = (0, _react.useCallback)(() => {
    onPaginationStepClick?.(slideIndex);
  }, [onPaginationStepClick, slideIndex]);
  const imagesVariants = (0, _react.useMemo)(() => ({
    url: mediaCarouselItem.src,
    backgroundColor: palette.grey[100],
    imageFormat: 'WebP',
    imageSizeMultiplier: 1,
    params: [{
      width: _constants.MEDIA_CAROUSEL_PAGINATION_STEP_ACTIVE_SIZE * 2,
      quality: 90
    }]
  }), [mediaCarouselItem.src, palette.grey]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.MEDIA_CAROUSEL_PAGINATION_STEP),
    hidden: hidden,
    isActive: isActive,
    onClick: onClick,
    children: mediaCarouselItem.type === 'image' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
      alt: mediaCarouselItem.imageProps?.alt,
      src: mediaCarouselItem.src,
      srcSet: (0, _imageSizesHelper.generateSrcSet)((0, _imageSizesHelper.getImageVariants)(imagesVariants)),
      sizes: `${_constants.MEDIA_CAROUSEL_PAGINATION_STEP_ACTIVE_SIZE * 2}px`,
      loading: hidden ? 'lazy' : 'eager'
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoPlaceholder.VideoPlaceholder, {
        isActive: isActive
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Play, {
        circleSize: isActive ? _constants.ACTIVE_PLAY_CIRCLE_SIZE : _constants.PLAY_CIRCLE_SIZE,
        playSize: isActive ? _constants.ACTIVE_PLAY_PLAY_SIZE : _constants.PLAY_PLAY_SIZE
      })]
    })
  });
};
exports.MediaCarouselPaginationStep = MediaCarouselPaginationStep;
//# sourceMappingURL=MediaCarouselPaginationStep.js.map